export default "__VITE_ASSET__DNfZgUfP__"